import featureFlags from 'shared/lib/featureFlags';
import { formatItemToQuery } from 'shared/lib/jobSearchQuery';

const typesMap = {
  field: 'fields',
  role: 'roles',
  skill: 'skills',
  language: 'languages',
  employment: 'employments',
  country: 'countries',
  city: 'cities',
  benefit: 'benefits',
  company: 'companies',
  text: 'texts',
  companySize: 'companySizes',
  companyType: 'companyTypes',
  homeoffice: 'homeoffice',
  remoteWork: 'remoteWork',
  suitableFor: 'suitableFor',
  b2b: 'b2b'
};

export const buildSearchQuery = params =>
  params.reduce((acc, curr) => {
    if (curr.type === 'rate' || curr.type === 'minRate') {
      acc.rate = {
        ...acc.rate,
        min: formatItemToQuery(curr)
      };
      return acc;
    }

    if (curr.type === 'maxRate') {
      acc.rate = {
        ...acc.rate,
        max: formatItemToQuery(curr)
      };
      return acc;
    }

    if (!featureFlags.search && !curr.not && (curr.type === 'skill' || curr.type === 'language')) {
      curr.required = true;
    }

    const key = typesMap[curr.type];
    if (key) {
      acc[key] = acc[key] || [];
      acc[key].push(formatItemToQuery(curr));
    } else {
      console.warn('Unknown type', curr.type);
    }

    return acc;
  }, {});

export const createFulltextItem = (t, value, isInverseSearch) => ({
  title: t(isInverseSearch ? 'common:suggestion.typeTextInverse' : 'common:suggestion.typeText', { value }),
  slug: value,
  type: 'text'
});

export default {
  buildSearchQuery,
  createFulltextItem,
};
